import styled from 'styled-components';

/* MetadataBar: ancho solo hasta el contenido, puntos separadores entre ítems */
const MetadataBarBase = styled.div`
  width: fit-content;
  background: rgba(250, 250, 250, 0.6);
  border: 1px solid ${(props) => props.theme.colors.highClearGray};
  border-radius: ${(props) => props.theme.borderRadius.base};
  padding: 4px 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-shrink: 0;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  padding: 0;
  border-width: 0;
  transition:
    max-height 0.2s ease-out,
    opacity 0.15s ease-out,
    padding 0.15s ease-out,
    border-width 0.15s ease-out;
`;

export const TitleWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ItemContainer = styled.div`
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid ${(props) => props.theme.colors.titanWhite};
  border-radius: ${(props) => props.theme.borderRadius.base};
  padding: ${(props) => props.theme.spacing.md};
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.sm};
  width: 100%;
  cursor: pointer;

  /* Compressed: Figma Spacing/2x (8px) padding per Compress Default */
  &[data-compressed] {
    padding: ${(props) => props.theme.spacing.sm};

    ${TitleWrapper} {
      overflow: hidden;
      min-width: 0;

      &,
      & > * {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  &:hover {
    background: ${(props) => props.theme.colors.aliceBlue};
  }

  /* Show metadata bar on hover when expanded (not compressed) */
  &:not([data-compressed]):hover ${MetadataBarBase} {
    max-height: 50px;
    opacity: 1;
    padding: 4px 8px;
    border-width: 1px;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${(props) => props.theme.spacing.xs};
  width: 100%;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing.xs};
  flex: 1;
  min-width: 0;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing.md};
  flex-shrink: 0;
`;

export const DescriptionRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 2px;
  font-size: ${(props) => props.theme.fontSize.sm};
  line-height: 20px;
  color: ${(props) => props.theme.colors.davysGrey};
  width: 100%;
  min-width: 0;
`;

export const Author = styled.span`
  color: ${(props) => props.theme.colors.greyEleven};
  flex-shrink: 0;
`;

export const DescriptionWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;

export const MetadataBar = MetadataBarBase;

export const MetadataIconItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing.xs};

  /* Punto separador entre ítems (excepto después del último) */
  &:not(:last-child)::after {
    content: '·';
    margin-left: 8px;
    margin-right: 8px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    color: ${(props) => props.theme.colors.davysGrey ?? '#9E9E9E'};
  }
`;

export const MetadataItem = styled.span`
  font-size: ${(props) => props.theme.fontSize.sm};
  font-weight: 500;
  color: ${(props) => props.theme.colors.davysGrey};
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
